import { Link, Outlet } from "react-router-dom";
import { SidebarInset, SidebarProvider, Toaster } from "@shortsworks/ui";
import { LNB } from "src/components/layouts/LNB";
import { Header } from "src/components/layouts/Header";

export const MainLayout = () => {
  return (
    <SidebarProvider>
      <LNB />
      <SidebarInset className="overscroll-none">
        <Header />
        <Outlet />
      </SidebarInset>
      <Toaster />
    </SidebarProvider>
  );
};
